var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 121,
    viewBox: "0 0 62 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2365 31.5059V120.83H54.6029V50.8892C51.6504 55.7973 41.719 62.0475 30.5607 62.0475C13.8807 62.0475 0 48.1859 0 31.5059C0 14.8259 13.8615 0.830078 30.5607 0.830078C47.2598 0.830078 60.7381 14.3274 61.1024 29.5503L61.2174 31.5059H61.2365ZM54.8522 29.5503C54.3537 17.5292 43.9238 7.21449 30.5607 7.21449C17.1975 7.21449 6.38432 17.8935 6.38432 31.5059C6.38432 45.1183 17.0633 55.6823 30.5607 55.6823C43.1953 55.6823 53.2609 46.4796 54.6029 34.2092L54.8522 29.5503Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber9);
export default __webpack_public_path__ + "static/media/NUMBER_9.44f73526ef65a6ad95e71a1d3c26eda0.svg";
export { ForwardRef as ReactComponent };